import FDictionary from '../__select';

export default class FDictionaryTypeTour extends FDictionary {
  dictionary = 'tourType';
}
